import { getPersistedLanguage } from "@/lib/language-storage"

type DeepReadonly<T> = T extends (infer R)[]
  ? ReadonlyArray<DeepReadonly<R>>
  : T extends object
    ? { readonly [K in keyof T]: DeepReadonly<T[K]> }
    : T

type CountryTranslation = {
  countryLookupTranslations: {
    countryName: string
    language: string
  }[]
} | null

export const getTranslatedCountry = (country?: CountryTranslation | DeepReadonly<CountryTranslation>) => {
  const language = getPersistedLanguage()
  if (!country?.countryLookupTranslations) return ""

  const [translated] =
    country?.countryLookupTranslations.filter((item) => item.language === language.toUpperCase()) || []
  return translated?.countryName || ""
}
